import { Component, OnInit, EventEmitter, Output, Inject, ViewChild, TemplateRef } from '@angular/core';
import { DOCUMENT } from '@angular/common';
import { EventService } from '../../core/services/event.service';

//Logout
import { AuthenticationService } from '../../core/services/auth.service';
import { Router } from '@angular/router';
import { TokenStorageService } from '../../core/services/token-storage.service';

// Language
import { CookieService } from 'ngx-cookie-service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { User } from '../../core/models/user.models';
import { RechargewalletComponent } from '../../shared/rechargewallet/rechargewallet.component';
import { GenericService } from '../../core/services/generic.service';
import { GlobalComponent } from '../../global-component';
import { ViewmemberdetailsComponent } from '../../shared/viewmemberdetails/viewmemberdetails.component';
import { GlobalsearchComponent } from '../../shared/globalsearch/globalsearch.component';
import { CustomValidatorMessage } from '../../core/helpers/customvalidators';
import { PushNotification } from '../../core/models/pushnotification.models';
import { NotificationsidewindowComponent } from '../../shared/notificationsidewindow/notificationsidewindow.component';
import { CurrentUser } from '../../core/models/currentuser.models';
import { ActionsSubject, Store } from '@ngrx/store';
import { buySubscription } from '../../store/subscription/subscription.actions';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { skip } from 'rxjs';
import { createTransactionsRecord, fetchUnreadNotifications, updateUnreadNotifications } from '../../store/common/common.actions';
import { environment } from '../../../environments/environment';

import { cloneDeep } from 'lodash';
import { MeetzaipopupComponent } from '../../shared/meetzaipopup/meetzaipopup.component';

export { }; declare global { interface Window { Calendly: any; } }

@UntilDestroy()
@Component({
  selector: 'app-topbar',
  templateUrl: './topbar.component.html',
  styleUrls: ['./topbar.component.scss']
})
export class TopbarComponent implements OnInit {

  @ViewChild('rechargeWalletModal') private rechargeWalletModal!: RechargewalletComponent;
  @ViewChild('viewProfileContent') private viewProfileContent!: ViewmemberdetailsComponent;
  @ViewChild('globalsearchContent') private globalsearchContent!: GlobalsearchComponent;
  @ViewChild('notificationswindow') private notificationswindow!: NotificationsidewindowComponent;
  // @ViewChild('meetzaiModal') private meetzaiModal!: MeetzaipopupComponent;

  messages: any
  element: any;
  mode: string | undefined;
  @Output() mobileMenuButtonClicked = new EventEmitter();
  flagvalue: any;
  valueset: any;
  countryName: any;
  cookieValue: any;
  userData!: User;
  currentuser!: CurrentUser;
  total = 0;
  cart_length: any = 0;
  totalNotify: number = 0;
  newNotify: number = 0;
  readNotify: number = 0;
  isDropdownOpen = false;
  @ViewChild('removenotification') removenotification !: TemplateRef<any>;
  notifyId: any;
  isuservendor = false;
  roles = GlobalComponent.ROLES;
  totalunreads = 0;
  allnotifications: PushNotification[] = [
    // {
    //   id: 1,
    //   attributes:{
    //     title: "test notificatgion",
    //     description: "This is a test notification",
    //     clientguid: "C1716907350634",
    //     recordguid: "R_1717683659962",
    //     servicetype: "planset",
    //     vendorguid: "C1716907350634",
    //     createdAt: "2022-12-19 23:54:03.001000"
    //   }
    // }
  ];
  unreadnotificationscount = 0;

  errormsgs = CustomValidatorMessage;

  userwalletbalance!: string;
  userearnings!: string;

  calendlyurl = environment.CALENDLY_URL;
  vendoruniquekey = environment.vendoruniquekey;
  isbuyingsubscription = false;
  areearningsvisible = false;
  huburl = ""

  constructor(@Inject(DOCUMENT) private document: any, private eventService: EventService, private modalService: NgbModal,
    public _cookiesService: CookieService, private authService: AuthenticationService,
    private router: Router, private genericService: GenericService, private tokenService: TokenStorageService,
    private store: Store, private actionListener$: ActionsSubject) { }

  ngOnInit() {
    this.isuservendor = this.genericService.getUserIsVendor();
    this.userData = this.tokenService.getUser();
    this.currentuser = this.tokenService.getCurrentUser();
    this.userwalletbalance = this.genericService.getUserWalletBalance()!;
    this.userearnings = this.genericService.getUserWalletBalance()!;
    this.element = document.documentElement;

    let transactionrecord = this.userData.accessrights?.find(access => { access.key_label == "transactions" });
    if(transactionrecord){
      this.areearningsvisible = true;
    }

    this.eventService.subscribe(GlobalComponent.broadcasts.currentuserprofileupdate, value => {
      console.log("current user profile update", value);
      if (value.guid == this.userData.guid) {
        this.userData = value;
        let token = this.currentuser.jwt;
        let updatedData = { "jwt": token, "user": this.userData };
        console.log("updatedData", updatedData);
        this.tokenService.saveUser({ "jwt": token, "user": this.userData });
      }
    });

    this.eventService.subscribe(GlobalComponent.broadcasts.walletrecharge, value => {
      let updatevalue = (Number(this.userwalletbalance) + Number(value));
      this.genericService.updateuserwalletbalance(updatevalue.toString());
      this.userwalletbalance = "" + updatevalue;
      this.userearnings = "" + updatevalue;
    });

    this.eventService.subscribe(GlobalComponent.broadcasts.paymentdone, value => {
      let updatevalue = (Number(this.userwalletbalance) - Number(value));
      this.genericService.updateuserwalletbalance(updatevalue.toString());
      this.userwalletbalance = "" + updatevalue;
      this.userearnings = "" + updatevalue;
    });

    this.eventService.subscribe(GlobalComponent.broadcasts.openglobalsearch, value => {
      this.openglobalsearch();
    });

    this.eventService.subscribe(GlobalComponent.broadcasts.newpushnotification, value => {
      console.log("push value", value);
      let notification = new PushNotification();
      notification.attributes = {
        title: "",
        description: "",
        clientguid: "",
        recordguid: "",
        servicetype: "",
        vendorguid: "",
        createdAt: ""
      }
      notification.attributes!.title = value.notification.title;
      notification.attributes!.description = value.notification.body;
      notification.attributes!.clientguid = value.data.clientguid;
      notification.attributes!.recordguid = value.data.recordguid;
      notification.attributes!.servicetype = value.data.servicetype;
      notification.attributes!.vendorguid = value.data.vendorguid;
      let tempnotifications = cloneDeep(this.allnotifications);
      tempnotifications.splice(0, 0, notification);
      this.allnotifications = tempnotifications;
      this.totalunreads += 1;
      this.unreadnotificationscount += 1;
    });

    this.eventService.subscribe(GlobalComponent.broadcasts.updateunreadnotificationscount, value => {
      this.totalunreads = this.totalunreads - this.unreadnotificationscount;
      this.unreadnotificationscount = value;
    });

    //FETCH UNREAD NOTIFICATIONS
    this.store.dispatch(fetchUnreadNotifications());

    this.registerActionListener();
  }

  onNavLinkClick(event: any) {
    // Prevent the default action and stop propagation if necessary
    event.preventDefault();
    event.stopPropagation();
  }

  /**
   * Toggle the menu bar when having mobile screen
   */
  toggleMobileMenu(event: any) {
    document.querySelector('.hamburger-icon')?.classList.toggle('open')
    event.preventDefault();
    this.mobileMenuButtonClicked.emit();
  }

  /**
   * Fullscreen method
   */
  fullscreen() {
    document.body.classList.toggle('fullscreen-enable');
    if (
      !document.fullscreenElement && !this.element.mozFullScreenElement &&
      !this.element.webkitFullscreenElement) {
      if (this.element.requestFullscreen) {
        this.element.requestFullscreen();
      } else if (this.element.mozRequestFullScreen) {
        /* Firefox */
        this.element.mozRequestFullScreen();
      } else if (this.element.webkitRequestFullscreen) {
        /* Chrome, Safari and Opera */
        this.element.webkitRequestFullscreen();
      } else if (this.element.msRequestFullscreen) {
        /* IE/Edge */
        this.element.msRequestFullscreen();
      }
    } else {
      if (this.document.exitFullscreen) {
        this.document.exitFullscreen();
      } else if (this.document.mozCancelFullScreen) {
        /* Firefox */
        this.document.mozCancelFullScreen();
      } else if (this.document.webkitExitFullscreen) {
        /* Chrome, Safari and Opera */
        this.document.webkitExitFullscreen();
      } else if (this.document.msExitFullscreen) {
        /* IE/Edge */
        this.document.msExitFullscreen();
      }
    }
  }
  /**
* Open modal
* @param content modal content
*/
  openModal(content: any) {
    // this.submitted = false;
    this.modalService.open(content, { centered: true });
  }

  scheduledemo() {
    window.Calendly.initPopupWidget({ url: this.calendlyurl }); return false;
  }

  /**
  * Topbar Light-Dark Mode Change
  */
  changeMode(mode: string) {
    this.mode = mode;
    this.tokenService.saveLayoutMode(mode);
    this.eventService.broadcast(GlobalComponent.broadcasts.changemode, mode);
    document.documentElement.setAttribute('data-bs-theme', mode);
  }

  /**
   * Logout the user
   */
  logout() {
    this.genericService.unreadmessages = [];
    this.eventService.broadcast(GlobalComponent.broadcasts.logout);
    this.authService.logout();
    this.router.navigate(['/auth/login']);
  }

  windowScroll() {
    if (document.body.scrollTop > 100 || document.documentElement.scrollTop > 100) {
      (document.getElementById("back-to-top") as HTMLElement).style.display = "block";
      document.getElementById('page-topbar')?.classList.add('topbar-shadow');
    } else {
      (document.getElementById("back-to-top") as HTMLElement).style.display = "none";
      document.getElementById('page-topbar')?.classList.remove('topbar-shadow');
    }
  }

  toggleDropdown(event: Event) {
    event.stopPropagation();
    if (this.isDropdownOpen) {
      this.isDropdownOpen = false;
    } else {
      this.isDropdownOpen = true;
    }
  }

  /**
   * Search Close Btn
   */
  closeBtn() {
    var searchOptions = document.getElementById("search-close-options") as HTMLAreaElement;
    var dropdown = document.getElementById("search-dropdown") as HTMLAreaElement;
    var searchInputReponsive = document.getElementById("search-options") as HTMLInputElement;
    dropdown.classList.remove("show");
    searchOptions.classList.add("d-none");
    searchInputReponsive.value = "";
  }

  upgrade() {
    this.router.navigate(["/subscriptions"]);
  }

  activate() {
    this.buySubscription();
  }

  //=======================================================================================

  openrechargewalletmodal() {
    this.rechargeWalletModal.openmodal();
  }

  // View Data Get
  openViewDetailsCanvas() {
    this.viewProfileContent.open(this.userData);
  }

  openglobalsearch() {
    this.globalsearchContent.open();
  }

  // openmeetzaipopup() {
  //   this.meetzaiModal.open();
  // }

  openChangepasswordDialog(content: any) {
    this.modalService.open(content, { size: 'md', centered: true });
  }

  dismisschangepasswordmodal() {
    this.modalService.dismissAll();
  }

  openRecordDetailsPage(item: PushNotification) {
    let postdata = item;
    const currentUserGuid = this.currentuser.user?.guid;

    let updatedUserguids;

    if (postdata.attributes?.userguids) {
      // Create a new array with updated user objects
      updatedUserguids = postdata.attributes.userguids.map((user: any) => {
        if (user.guid === currentUserGuid) {
          return { ...user, status: "read" };
        }
        return user;
      });
    }

    // Create a new postdata object without the attributes key
    const newPostdata = {
      userguids: updatedUserguids
    };

    this.store.dispatch(updateUnreadNotifications({ id: item.id!, postdata: newPostdata }))
    this.router.navigate(['/' + item.attributes!.servicetype + '/details/' + item.attributes!.recordguid]);
  }

  opennotificationscanvas() {
    return this.notificationswindow.open();
  }

  //Buy Subscription
  buySubscription() {
    this.isbuyingsubscription = true;
    let curr_date = new Date();
    let end_date = new Date();
    let planTime = 'yearly';
    // console.log('selected plan', this.selectedplan);
    // switch(this.selectedplan.planTime) {
    switch (planTime) {
      case "monthly":
        end_date.setMonth(curr_date.getMonth() + 1);
        // end_date.setMinutes(end_date.getMinutes() + 1);
        planTime = 'monthly';
        break;

      case "yearly":
        end_date.setFullYear(curr_date.getFullYear() + 1);
        planTime = 'yearly';
        break;

      default:
        break;
    }
    console.log("end date", end_date);
    // let end_date = curr_date.get
    let postdata = {
      startdate: curr_date,
      enddate: end_date,
      subscriptionend: false, //KEY FOR CHECK SUBSCRIPTION IS SUBSCRIBED OR NOT
      vendorguid: this.tokenService.getVendorGUID(),
      planactivated: true,
      planTime: planTime
    }

    this.store.dispatch(buySubscription({ postdata: postdata }));
  }


  registerActionListener() {
    this.actionListener$.pipe(untilDestroyed(this)).pipe(
      skip(1) // optional: skips initial logging done by ngrx
    ).subscribe((action: any) => {
      console.info('ngrx action', action);
      switch (action.type) {
        case "[Subscription] Buy Subscription Success":
          if (this.isbuyingsubscription) {
            console.log("inside success");
            this.createTransaction();
          }
          break;
        case "[Subscription] Buy Subscription Failure":
          if (this.isbuyingsubscription) {
            this.isbuyingsubscription = false;
          }
          break;
        case "[Common] Create Transaction Record Success":
          if (this.isbuyingsubscription) {
            this.isbuyingsubscription = false;
            this.modalService.dismissAll();
          }
          break;
        case "[Common] Create Transaction Record Failure":
          if (this.isbuyingsubscription) {
            this.isbuyingsubscription = false;
          }
          break;
        case "[Common] Fetch Unread Notifications Success":
          this.allnotifications = action.notifications.data;
          this.unreadnotificationscount += this.allnotifications.length;
          this.totalunreads += this.allnotifications.length;
          break;

        case '[Common] Update Unread Notifications Success':
          this.unreadnotificationscount -= 1;
          this.totalunreads -= 1;
          break;

        case "[Authentication] Change Password Success":
            {
              this.modalService.dismissAll();
              break;
            }

        default:
          break;
      }
    });
  }

  //CREATE TRANSACTIONS
  createTransaction() {
    let postdata = {
      amount: 0,
      company: this.userData.company,
      details: 'YEARLY SUBSCRIPTION PURCHASE',
      type: 'withdraw',
      status: 'success',
      clientguid: this.userData.guid,
      vendorguid: this.tokenService.getVendorGUID(),
      performerguid: this.userData.guid,
      servicetype: 'subscription',
      source: 'web',
      jobguid: ''
    }

    this.store.dispatch(createTransactionsRecord({ postdata: postdata }));
  }

  async openHubPortal() {
    const email = this.tokenService.getCurrentUser().user?.email || '';
    const password = this.tokenService.getCurrentUser().user?.password || '';
    const encryptedemail = await this.genericService.encryptValue(email);
    this.huburl = GlobalComponent.HUB_API_URL + `?usere=${encryptedemail}&userp=${password}`;

    // Open the generated URL in a new tab
    window.open(this.huburl, '_blank');
  }
}
